export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_RESPONSE = "GET_SERVICES_RESPONSE";

export const ADD_SERVICE_REQUEST = "ADD_SERVICE_REQUEST";

export const EDIT_SERVICE_REQUEST = "EDIT_SERVICE_REQUEST";

export const GET_SERVICE_DETAILS_REQUEST = "GET_SERVICE_DETAILS_REQUEST";
export const GET_SERVICE_DETAILS_RESPONSE = "GET_SERVICE_DETAILS_RESPONSE";

export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";

export const EDIT_SERVICE_BULK_REQUEST = "EDIT_SERVICE_BULK_REQUEST";